import { media,spacing } from '@gyym/ui'
import styled from 'styled-components'

interface ContainerProps {
  maxWidth: number
}

export const Container = styled.div<ContainerProps>`
  box-sizing: border-box;
  max-width: ${({ maxWidth }) => maxWidth}px;
  margin: 0 auto;
  width: 100%;
  padding: ${spacing(0, 4, 10)};

  ${media.pc} {
    padding: ${spacing(0, 10, 28)};
  }
`
